export enum TaxTypes {
  TAX = "tax",
  TAX_PER_CAPITA = "taxPerCapita",
  RATE = "rate",
}

export enum AverageTypes {
  LARGER_ABOVE_10,
  LARGER_BELOW_10,
  SMALLER_OR_EQUAL,
}
